<template>
  <div class="main">
    <div class="agree">
      <div>
        <div class="title">用户授权协议</div>
        <div class="text">
          <div class="indent">
            本协议是由【上海屹零科技有限公司】(以下简称“ 我们”)与用户(以下简称“您”)就个人信息的收集、使用、存储和分享所订立 的有效合约，你通过本页面点击确认，即表示您同意接受本协议的全部约定内容以及本
            协议有关的已经发布或将来可能发布的各项规则、公告或通知(以下统称“规则” )。<span class="weight"> 为了您的合法权益，请您在使用本服务前务必仔细阅读本协议的全部内容(特   别是以粗体/下划线标注的内容)。如果您不同意本协议的任意内
            容，或者无法准确理解本协议任何条款的含义，请不要进行授权及后续操作。</span>
          </div>
          <div class="indent">
            一 、当您在申请我们提供的融资贷款等咨询服务，我们会收集并使用您的个人 信息。同时为了增加您的申请贷款通过机会，我们将会通过电话、短信等形 式 与您取得联系，进一步为您提供服务。我们承诺，在未征得您授权同意前不会
            向其他任何第三方分享根据本协议所收集、存储的您的个人信息，如有违反，我们 将承担全部责任。我们承诺，未经您允许不得非法收集、使用、加工、传输您的个
            人信息，不得非法买卖、提供或者公开您的个人信息；不得从事危害国家安全、 公共利益的个人信息处理活动。
          </div>
          <div class="indent">
            二、您同意本协议以数据电文形式订立。如您通过平台方网络页面点击“同意 ”或“注册”或“申请”或“接受用户授权协议”(以网页显示为准),即视为 您已阅读理解本协议的全部内容并同意我们出于本协议所述目的，在收集并使用您
            的个人信息后为您提供融资贷款及贷款咨询服务【包括但不限于授信审核、贷款 】,但前述相关服务是否通过或成功均应以我们对您提供的真实个人信息进行充 分审核、评估后的结果为准。
          </div>
          <div class="indent weight">
            三、我们处理个人信息的法律依据
          </div>
          <div class="indent">
            我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规 范》 (GB/T 35273-2020)以及其他相关法律法规收集和使用您的个人敏感信息
            以及其他个人信息，为您提供产品和/或服务。我们只会在征得您同意的情况下 收集您的信息，在某些情况下，我们可能还会基于法律义务或者履行合同之必需向您 收集个人敏感信息，或者可能需要个人信息来保护您的重要利益。
          </div>
          <div class="indent weight">
            四 、个人信息收集方式、范围、目的及用途
          </div>
          <div class="indent">
            本协议中所指您的个人信息含个人敏感信息及其他个人信息。您理解并同意 为了提高您的体验，向您提供更适合您的定制化服务，我们需要您提供如下信 息，以下部分信息属于您的个人敏感信息若您选择不提供该类信息，则可能无法正
            常使用服务中的下一步功能，但不影响您使用服务中的其他功能。若您提供了您的 个人敏感信息，即表示您同意我们按本协议所述目的和方式来处理您的个人敏感 信息。同时我们也有权存储该类信息并根据本协议的约定使用和分享该类信息。
          </div>

          <div>
            <table cellpadding="0" cellspacing="8" border="1" style="margin: 0.1rem 0rem;">
              <tr style="font-size: 0.14rem;font-weight: bolder;">
                <td>序号</td>
                <td>信息类型</td>
                <td>信息内容</td>
                <td>目的及用途</td>
              </tr>
              <tr>
                <td>1</td>
                <td>个人身份信息</td>
                <td>姓名、性别、年龄、户籍 、现居住住址、电子邮箱 、电话号码、身份证号、 工作信息、学历、婚姻状 况、紧急联系 人、设 备信息、生物特征、及通 讯录等个人敏感信息及 基本个人信息</td>
                <td>
                  <div class="indent">
                    1.在我们提供服务时用 于身份验证、客户服务、安 全防范、存档和备份用途，
                    确保我们向您提供的产品
                    和服务的安全性；这些信息 用于评估您的信用资质，评 定是否通过您的申请，同时提供 您使用的各项服务，并维护 、改进这些服务；
                  </div>
                  <div class="indent">
                    2.便于我们存储您的偏 好，帮您省去重复输入注册 信息的步骤，并帮助判断您 的账户安全状态，以为您提供 更轻松的用户体验和服务
                  </div>
                  <div class="indent">
                    3.评估、改善我们的广 告投放和其他促销及推广
                    <span class="weight">活动的效果。我们将使用这 些信息来分析您的偏好以
                    改进我们的服务。并且这些 信息能够提升我们对您的
                    评价，使您可以获得我们提 供的更高层级的服务。</span>
                  </div>
                  <div class="indent weight">
                    4.邀请您参与有关我们 服务的调查；
                  </div>
                  <div class="indent weight">
                    5.为了保证我们的服务 质量，在您填写手机运营服 务商及密码时，我们需要您 授权我们使用您的电话号
                    码及密码去依法设立的第
                    三方查询机构查询并存储
                    您近期的话费账单等信息；
                  </div>
                  <div class="indent">
                    <span class="weight">6.为了向您提供更好的 服务，在您享受我们为您提 供的资信查询服务填写身
                    份信息时，我们需要您授权我们使用您的姓名、身份证</span>
                    号码、手机号等个人信息去 依法设立的第三方查询机 构查询并存储您的行为记
                    录等信息。
                  </div>
                </td>
              </tr>


              <tr>
                <td>2</td>
                <td>信用信息</td>
                <td>征信记录和信用报告</td>
                <td>
                  用于评估您的信用资
                  质，评定是否通过您的申 请，同时提供您使用的各项 服务，并维护、改进这些服务
                </td>
              </tr>


              <tr>
                <td>3</td>
                <td>财产信息</td>
                <td>财税信息、房产信息、 车辆信息、基金、保险、股 票、信托、债务、收入情 况、银行卡号、开户行、 开户地址等投资理财信 息和负债信息 等</td>
                <td>
                  <div class="indent">
                    1.用于评估您的信用资 质，评定是否通过您的申 请，同时提供您使用的各项 服务，并维护、改进这些服务
                  </div>
                  <div class="indent">
                    2.便于我们存储您的偏 好，帮您省去重复输入注册 信息的步骤，并帮助判断您 的账户安全状态，以为您提 供更轻松的用户体验和服 务。
                  </div>
                </td>
              </tr>


              <tr>
                <td>4</td>
                <td>根据相关法 律法规的规 定，可以在 不征得您的 <span class="weight">授权同意的 情况下收
                  集、使用一 些必要的个 人信息</span></td>
                <td>
                  <div class="indent">
                    1)与个人信息控制者 履行法律法规规定的 义务相关的
                    2)与国家安全、国防 安全直接相关的；
                    3)与公共安全、公共 卫生、重大公共利益直
                    接相关的；
                    4)与犯罪侦查、起诉、审 判和判决执行等直 接相关的；
                    5)出于维护您或其他 个人的生命、财产等重
                    大合法权益但又很难 得到本人同意的；
                    6)所收集的个人信息 是您自行向社会公众
                    <span class="weight">
                    公开的 ；
                    7)从合法公开披露的  信息中收集到您的个  人信息，如从合法的新 闻报道、政府信息公开 等 渠 道 ；
                    8)根据您的要求签订 和履行合同所必需
                    的 ；
                    9)用于维护本平台的  产品和/或服务的安全 稳定运行所必需的，例 如发现、处置产品或服 务的故障；
                    10)法律法规规定的 其他情形。
                    </span>
                  </div>
                </td>
                <td>
                  根据相关法律法规的规定
                </td>
              </tr>
            </table>
          </div>

          <div class="indent weight">
            五 、我们如何共享、转让、公开披露您的个人信息
          </div>
          <div class="indent">
            我们仅会出于合法、正当、必要、特定、明确的目的共享、转让、披露您的个 人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密
            协议，要求他们按照协议、本协议以及其他任何相关的保密和安全措施来处理信息
          </div>

          <div class="indent">
            5.1共享
          </div>
          <div class="indent">
            我们对您的信息承担保密义务。除以下情形外，未经您的同意，我们及我们的关联 公司不会与任何第三方分享您的个人信息：
          </div>
          <div class="indent weight">
            5.1.1在获得您的明确同意后，我们会与其他方共享您的个人信息。
          </div>

          <div class="indent weight">
            5.1.2根据有关法律法规要求向有权的仲裁机构或司法、行政、立法等权力 机关提供您的个人资料和信息。
          </div>
          <div class="indent">
            <span class="weight">5.1.3提供给我们的关联方、合作机构(关联方及合作机构具体名称 ：深圳市非凡智企控股集团有限公司  ,下同)  以</span>
            用于完成我们对您提供的服务(包括但不限于对您的个人资料和信息进行核实 、对您的信用情况进行评估等),我们只会共享完成服务所必要的个人信息，且受本 协议中声明目的的约束。
          </div>
          <div class="indent">
            5.1.4我们及关联公司及相关合作伙伴、第三方服务商可能定期或不定期向 您发送有关产品、服务或相关活动的信息，您同意接收上述信息。
          </div>

          <div class="indent">
            5.1.5提供给您通过我们提供的服务达成交易的交易方。
          </div>
          <div class="indent">
            5.1.6其他经您许可的情形。
          </div>
          <div class="indent">
            5.2转让
          </div>
          <div class="indent">
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
          </div>

          <div class="indent weight">
            5.2.1在获得您的明确同意后，我们会向其他方转让您的个人信息；
          </div>
          <div class="indent">
            5.2.2在本产品服务提供者发生合并、收购或破产清算情形，或其他涉及合并 、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的
            公司、组织继续受本协议的约束，否则我们将要求该公司、组织和个人重新向您征求 授权同意。
          </div>
          <div class="indent">
            5.3公开披露
          </div>
          <div class="indent">
            我们可能基于以下目的披露您的个人信息：
          </div>


          <div class="indent">
            5.3.1遵守适用的法律法规等有关规定；
          </div>
          <div class="indent">
            5.3.2遵守法院判决、裁定或其他法律程序的规定；
          </div>
          <div class="indent">
            5.3.3遵守相关政府机关或其他法定授权组织的要求；
          </div>
          <div class="indent">
            5.3.4我们有理由确信需要遵守法律法规等有关规定；
          </div>
          <div class="indent">
            5.3.5为执行相关服务隐私政策或本协议、维护社会公共利益，为保护我们 的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益 合理且必要的用途。
          </div>
          <div class="indent">
            5.4共享、转让、公开披露您个人信息无需事先征得您的授权同意：
          </div>
          <div class="indent">
            5.4.1与国家安全、国防安全有关的；
          </div>
          <div class="indent">
            5.4.2与公共安全、公共卫生、重大公共利益有关的；
          </div>
          <div class="indent">
            5.4.3与犯罪侦查、起诉、审判和判决执行等有关的；
          </div>
          <div class="indent">
            5.4.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本 人同意的；
          </div>
          <div class="indent">
            5.4.5您自行向社会公众公开的个人信息；
          </div>
          <div class="indent">
            5.4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信 息公开等渠道。
          </div>
          <div class="indent">
            5.5根据法律规定，分享、转让已经去标识化处理的个人信息，且确保数据接 收方无法复原并重新识别个人信息主体的，不属于个人信息的对外分享、转让及公 开行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
          </div>


          <div class="indent weight">
            六、我们如何存储个人信息
          </div>
          <div class="indent">
            6.1存储地点：我们依照法律法规的规定，将在境内运营过程中收集和产生的 您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外 ,如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。
          </div>
          <div class="indent">
            6. 2存储期限：我们仅在为您提供本协议服务之目的所必需的期间内保留您的 个人信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超 出 必要期限后，我们将对您的个人信息进行删除、去标识化或匿名化处理，但法
            律法规另有规定的除外。
          </div>


          <div class="indent weight">
            七、您如何访问和控制及注销自己的信息
          </div>
          <div class="indent">
            7.1您可以在使用我们服务的过程中访问您的个人信息，并根据对应个人信息的 管理方式自行完成或要求我们进行、修改和删除。我们将采取适当的技术手段或
            提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的个人信息或 使用相关产品服务时提供的其他个人信息。您访问、修改和删除个人信息的范围和
            方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止 分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供 商的关闭方式停止分享，建议您仔细阅读相关指引。
          </div>


          <div class="indent">
            7.2当您发现我们除了关于您的个人信息有错误时，您有权要求我们做出更 正或者补充。您可以通过本协议中提及的方式提出更正或补充申请。
          </div>


          <div class="indent">
            7.3您可以通过本协议中提及的方式删除您的部分个人信息。在以下情形中，您 可以向我们申请删除您的个人信息：
          </div>
          <div class="indent">
            7.3.1如果我们处理个人信息的行为违反了法律法规；
          </div>
          <div class="indent">
            7.3.2如果我们在未征得您明确的同意下收集、使用您的个人信息；
          </div>
          <div class="indent">
            7.3.3如果我们处理个人信息的行为严重违反了与您的约定；
          </div>
          <div class="indent">
            7.3.4如果您不再使用我们的产品或服务，或您主动注销了账号；
          </div>
          <div class="indent">
            7.3.5如果我们永久不再为您提供产品或服务。
          </div>
          <div class="indent">
            7.4在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证， 以保障个人信息的安全。
          </div>
          <div class="indent">
            7.5您可以通过联系我们的客服提交注销账户的申请。在您注销账户后，我 们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息或使其匿名 化处理。在您注销账号前，我们将验证您的个人身份、安全状态、设备信息等。
            申请注销前请确认您的账号是否满足以下注销条件：
          </div>
          <div class="indent">
            7.5.1账号处于安全状态
          </div>
          <div class="indent">
            7.5.2近30天没有出现更换手机号、或更换手机等敏感信息变更操作；
          </div>
          <div class="indent">
            7.5.3账号无未完成的业务；
          </div>
          <div class="indent">
            7.5.4没有正在进行中，或者尚未确认完成的交易。
          </div>
          <div class="indent">
            7.5.5账号无任何纠纷，包括举报。
          </div>
          <div class="indent">
            注销账号后的影响：注销账号后，您将永远失去账号记录、个人资料且无法恢复， 请谨慎操作。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们
            将删除有关您的相关信息或进行匿名化处理，但法律法规另有规定的除外。
          </div>
          <div class="indent">
            7.6改变您授权同意的范围
          </div>
          <div class="indent">
            7.6.1有些个人信息是使用本产品服务所必需的，但大多数其他个人信息的 提供是由您决定的。您可以通过删除个人信息、关闭设备功能等方式改变您授权 我们继续收集个人信息的范围或撤回您的授权。
          </div>
          <div class="indent">
            7.6.2当撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再 处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而已开展 的信息处理。
          </div>
          <div class="indent">
            7.7请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要
          </div>
          <div class="indent weight">
            八、我们如何处理未成年人的注册行为
          </div>
          <div class="indent">
            8.1我们的产品、网站和服务面向成年人，在注册登录时会进行验证码查验，后 续服务环节(如实名认证时)均会设置监管机制(如生物识别程序),最大限度避免 未成年人窃取、冒用他人信息建立个人信息主体账户或类似情形。
          </div>
          <div class="indent">
            8.2若您作为父母或监护人发现了上述情形，请及时与我们联系，我们会尽 快删除相关数据。
          </div>
          <div class="indent weight">
            九 、自动索引技术的使用
          </div>
          <div class="indent">
            为了更好的提供服务，我们会使用自动索引和类似的技术来提供我们的服务 ,并协助收集数据。您同意我们使用这类技术获得您浏览第三方平台所产生的个 人数据信息，我们将使用这些信息来分析您的偏好以改进我们的服务。并且这些信
            息能够提升我们对您的评价，使您可以获得我们提供的更高层级的服务。
          </div>
          <div class="indent weight">
            十、电子签约授权和相关服务说明
          </div>
          <div class="indent weight">
            根据相关法律法规规定同时为了实现平台业务基本功能，在您选择相关产品或 服务时，可能会需要提供您真实的身份信息(包括但不限于姓名、身份证信息 、手机号、银行卡、面部识别特征等)。在您(无论您是发起方还是受邀方)使
            用第三方电子签约服务平台提供的电子签约和相关服务时，可能会需要您在您的设 备中开启摄像头和相册的权限以实现该目的。此外，为了完成电子签约所需的必要认
            证，这些信息属于个人敏感信息，对于电子签约功能或服务而言属于必要信息， 您可以拒绝提供，但拒绝提供将使您无法使用电子签约的基本功能。如您点击“同 意”(具体方式以平台页面展示为准)即视为我们及关联方已经获得了您相关个
            人信息主体的全部授权并同意，如您对以下任一约定有异议的请勿点击“同意”。具 体如下：
          </div>
          <div class="indent">
            10.1您同意授权我们及关联方为您在第三方电子签约服务平台申请开通数
            字证书，并同意在开通数字证书过程中将您的姓名、身份证号码共享给第三方电子 签约服务平台。您同意将该证书托管于第三方电子签约服务平台或我们的服务器 ,并同意我们及关联方对数字证书的统一管理规定管理。
          </div>
          <div class="indent">
            10.2您不可撤销地授权我们及关联方为实现平台服务之目的调取、使用您的 数字证书、电子签名以签署相关文件及协议，您通过电子签章签署确认的文件将包括
            但不限于用户注册服务协议、用户个人信息授权书等。即您同意并确认一经通过 点击“同意”按钮后，即视为您同意采取静默签约的形式进行电子签约。
          </div>
          <div class="indent">
            10.3您同意并确认，您与我们或您通过我们平台与第三方签署的电子合同或您 单方确认、提交的文件均授权我们及关联方通过电子签章进行签署确认，
          </div>
          <div class="indent">
            签署后形成的电子文件为您合法有效的签署文件；
          </div>
          <div class="indent weight">
            10.4您知悉并确认，您通过电子签章签署的合同效力等同于您在线下签字或 盖章签署确认的合同。您对相关合同内容均予以认可并无任何异议，并无条件 接受相关合同、文件等约束。
          </div>
          <div class="indent weight">
            十一、您的个人信息保护
          </div>
          <div class="indent">
            11.1我们非常重视您的个人信息安全。我们将采取不低于一般行业惯例对于通过 您的授权所获取的信息进行保护，并以一切商业上的合理努力确保这些信息的安全
            。我们组织内部也将根据国家相关法律、法规、规章等制度制定严格的隐私和安全 准则，设立个人信息保护责任部门，并要求全体员工知晓和遵守，对可能接触到您的信息
            的工作人员采用最小够用授权原则，即仅允许有必要知晓这些信息的本产品和其他
            关联公司的员工在采取合理的措施验证身份之后，访问或修改这些信息。同时，我们会严格要求他们履行保密及安全义务，如果未能履行这些义务，其会被追究法律责任或
            被终止与本产品的合作关系。通常，平台的员工或与平台合作的第三方并不会查看在 平台系统中存储的用户信息，当我们得知您可能违反了平台的产品及服务条款时，
            为了及时提醒您以免您留下不良信用记录，我们会根据本协议或您与我们另行达 成的约定使用您的信息。
          </div>
          <div class="indent">
            11.2基于防火墙或其他安全软件可能发生故障，或按照当前商业上可以采取的 安全手段也难以避免或及时消除的故障及破坏，将可能导致您的信息遭到外部访问 、窃取或删除，此等情形下我们不承担相应的责任。
          </div>


          <div class="indent">
            11.3因不可抗力所导致的用户资料及信息泄露(包含但不限于黑客攻击、第三 方自身系统缺陷等),我们不承担相应的责任，但会尽最大的努力保证您的信息安全 ,防止泄露范围进一步扩大。
          </div>
          <div class="indent">
            11.4您在我们平台的账户信息是非常重要的，要妥善保管。使用您的账号、密码 等账户信息登录平台进行的操作视为您个人的操作，您应当承担该等操作产生的一
            切法律后果。如果您因为自身的保管不善、委托他人使用或者其他个人原因导致 您权益受损，我们将不承担相关责任。
          </div>
          <div class="indent weight">
            十二、本协议的修订与通知
          </div>
          <div class="indent">
            我们将根据相关法律、法规、政策的要求及提供服务的需要不时地修改本协 议并于平台首页发布公告或其他方式来通知，您应当注意本协议的变更。若您在 本协议公告变更后继续使用本服务，视为您已充分阅读、理解并接受修改后的政策
            内容，也将遵循修改后的政策使用本平台的服务；同时就您在隐私政策和具体规则修 订前通过本平台进行的交易及其效力，视为您已同意并已按照本协议及有关规则进 行了相应的授权和追认。
          </div>
          <div class="indent weight">
            十三、其他
          </div>
          <div class="indent">
            13.1再次提示您，在您接受本协议之前，请务必审慎阅读本协议，充分理解各条款内容 ,尤其是其中免除或者限制我司责任和限制用户权利、约定法律适用和争议解决等条
            款，该等免责、限制及争议解决方式和管辖条款通常以加粗、颜色标记或其他合理方 式提示您注意。
          </div>
          <div class="indent">
            13.2本协议未尽事项按照我们现有及不时发布的各项规则执行。
          </div>
          <div class="indent">
            13.3如本协议中的任何一条或多条被确认为无效，该无效条款并不影响本协议 其他条款的效力。
          </div>

          <div class="indent">
            13. 4您同意，凡因本协议引起的任何与之有关的争议、纠纷，首先通过友好 协商的方式解决，如协商不能达成一致的，任何一方均可向被告住所地有管辖权 的人民法院提起诉讼。
          </div>

          <div class="indent weight">
            用户姓名：{{ name }}
          </div>
          <div class="indent weight">
            联系电话：{{ phone }}
          </div>
          <div class="indent weight">
            UID：{{ uid }}
          </div>
          <div class="indent weight">
            公司名称：上海屹零科技有限公司
          </div>
          <div class="indent weight">
            企业信用信息代码：91310115MA1HBPP95L
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "authCch",
  data() {
    return {
      uid: "",
      phone: "",
      name: "",
    }
  }, created() {
    this.util.title('授权书');
    var uid = this.$route.query.uid;
    if (uid) {
      this.uid = uid;
    }
    var phone = this.$route.query.phone;
    if (phone) {
      this.phone = phone;
    }
    var name = this.$route.query.name;
    if (name) {
      this.name = name;
    }
  }, methods: {}
}
</script>

<style scoped>
* {
  margin: 0px;
  padding: 0px;
}

.indent {
  text-indent: 25px;
}

.weight {
  font-weight: bolder;
}

.main {
  width: 100%;
  height: 100%;
}

.main .agree {
  height: 100%;
  background: #FFFFFF;
  padding: 0.05rem 0.15rem 0.15rem;
  overflow-y: scroll;
}

.main .agree .tip {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2F2F2F;
}

.main .agree .title {
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
  margin-bottom: 0.1rem;
}

.main .agree .text {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.2rem;
}


</style>
